<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon> </v-btn
          >Edit Welcome Bonus Usage Range Points
        </v-card-title>
        <v-card-text>
          <div v-for="(level, index) in form.pointRange" :key="index">
            <v-row>
              <v-col cols="12" class="d-flex align-center">
                <h4 style="display: inline">Level {{ index + 1 }}</h4>
                <v-btn
                  v-if="form.pointRange.length > 1"
                  icon
                  class="ml-2"
                  color="red"
                  @click="removeLevel(index)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model.number="level.min_amount"
                  label="Min Amount"
                  outlined
                  :error-messages="errors.min_amount"
                ></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model.number="level.max_amount"
                  label="Max Amount"
                  outlined
                  :error-messages="errors.max_amount"
                ></v-text-field>
              </v-col>
              <v-col sm="4">
                <v-text-field
                  v-model.number="level.usage_point"
                  label="Used Points Per Sale Amount"
                  outlined
                  :error-messages="errors.usage_point"
                ></v-text-field>
              </v-col>
            </v-row>
          </div>

          <v-btn class="mt-2 mb-4" color="secondary" @click="addLevel">
            <v-icon left>mdi-plus</v-icon>
            Add Next Level
          </v-btn>

          <v-divider class="my-5"> </v-divider>
          <v-btn
            rounded
            color="primary"
            :loading="isLoading"
            :disabled="isLoading"
            @click="save"
          >
            Update Welcome Bonus
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";

export default {
  name: "WelcomeBonusIdPage",
  data() {
    return {
      form: {
        is_active: false,
        pointRange: [],
      },
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    addLevel() {
      this.form.pointRange.push({
        min_liters: null,
        max_liters: null,
        points_per_liter: null,
      });
    },
    removeLevel(index) {
      this.form.pointRange.splice(index, 1);
    },
    async getData() {
      this.isLoading = true;
      axios
        .get(`/welcome_bonus_usage_ranges`)
        .then((response) => {
          this.form.pointRange = response.data.data;
          this.old_json = response.data.data;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        console.log(this.form);
        await axios.post(`/welcome_bonus_usage_ranges`, this.form);
        await this.saveUserTimestamp(this.old_json, this.form);
        this.isLoading = false;
      } catch (e) {
        this.isLoading = false;
      }
    },
    async saveUserTimestamp() {
      try {
        let form = {
          from_path: `/welcome_bonus_usage_ranges/${this.form.id}`,
          from_name: "WelcomeBonusIdPage",
          user_id: this.user.id,
          old_json: JSON.stringify(this.old_json),
          new_json: JSON.stringify(this.form),
        };
        await axios.post(`/user_timestamps`, form);
        this.$router.back();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
